module.exports = __webpack_public_path__ + "img/astral-txt_2.825613d2.svg";